var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modals" },
    [
      _c("portal-target", { attrs: { name: "photoGallery" } }),
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "ChoiceRegion" } }),
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "SearchSuggest" } }),
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "MenuCatalogM" } }),
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "NoAvailable" } }),
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "PdfReader" } }),
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "FastCert" } }),
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "CallOrderModalD" } }),
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "CallEditOrderModalD" } }),
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "PartnerLinkModal" } }),
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "CallArrivalProductModalD" } }),
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "ModalWidgetRecommendation" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }